import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, MaxWidth, Rectangle, Shadow, Typography } from '@pitchero/react-ui';
import VideoIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Video';
import Icon from '../icon';
import IconWithTheme from '../icon-with-theme';
import { Trans } from '../../lib/i18n';
import TabContainer from '../navigation/tab-container';
import NavigationTabLink from '../navigation/tab-link';

const MediaTypeTabs = ({ mediaType, search, teamId }) => {
  const linkParams = teamId ? { teamId } : {};
  if (search) {
    linkParams.search = search;
  }

  return (
    <Shadow>
      <Rectangle fill="#fff" borderTop="thinLightGrey">
        <Cushion
          horizontal="large"
          responsive={[
            {
              maxWidth: 720,
              props: { horizontal: 'small' },
            },
          ]}
          component="div"
        >
          <MaxWidth component="div" maxWidth={1366} center>
            <TabContainer style={{ textAlign: 'left' }}>
              <NavigationTabLink
                route={teamId ? 'media.albums.team' : 'media.albums'}
                isActive={mediaType === 'albums'}
                params={linkParams}
              >
                <Typography preset="name" color={mediaType === 'albums' ? 'black' : 'dustygrey'}>
                  <Cushion right="small">
                    <Icon name="camera" size={18} topOffset={4} />
                  </Cushion>
                  <Trans i18nKey="common:albums">Albums</Trans>
                </Typography>
              </NavigationTabLink>
              <NavigationTabLink
                route={teamId ? 'media.videos.team' : 'media.videos'}
                isActive={mediaType === 'videos'}
                params={linkParams}
              >
                <Typography preset="name" color={mediaType === 'videos' ? 'black' : 'dustygrey'}>
                  <Cushion right="small">
                    <IconWithTheme>
                      <VideoIcon
                        size={18}
                        topOffset={4}
                        colorOne={mediaType === 'videos' ? 'black' : 'dustygrey'}
                        colorTwo="white"
                      />
                    </IconWithTheme>
                  </Cushion>
                  <Trans i18nKey="common:videos">Videos</Trans>
                </Typography>
              </NavigationTabLink>
            </TabContainer>
          </MaxWidth>
        </Cushion>
      </Rectangle>
    </Shadow>
  );
};

MediaTypeTabs.defaultProps = {
  search: null,
  teamId: null,
};

MediaTypeTabs.propTypes = {
  mediaType: PropTypes.string.isRequired,
  search: PropTypes.string,
  teamId: PropTypes.number,
};
export default MediaTypeTabs;
